module.exports = __webpack_public_path__ + "static/media/AA491C0D-6DD8-4082-AD7C-ABFBBAE548C4.bdb1a038.JPG";